import React, {Fragment} from "react";
import {PrefixedField, PrefixedError} from "./PrefixField";
import SelectField from "./SelectField";
import PropTypes from "prop-types"
import InputField from "./InputField";
import {composeValidators, limit, phoneNumber, required} from "../../helpers/ValidateHelper";

function PhoneFiled({name, options}) {
    options = options.map(option => {
        return {
            value: option.value,
            label: option.label,
            icon: `/_core/assets/common/css/flags/4x3/${option.iso}.svg`,
        }
    })

    return <Fragment>
        <div className="control-phone">
            <PrefixedField
                name={`${name}.code`}
                component={SelectField}
                options={options}
                isSearchable={true}
                className="control-phone-code"
            />
            <PrefixedField
                name={`${name}.number`}
                component={InputField}
                className="control-input control-phone-number"
                placeholder="0000000000"
                inputProps={{
                    inputMode: 'tel',
                }}
                validate={composeValidators(
                    required('Please provide a valid phone number'),
                    phoneNumber('Please provide a valid phone number')
                )}
            />
        </div>
        <PrefixedError name={`${name}.number`} />
    </Fragment>
}

PhoneFiled.propTypes = {
    name: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
}

export default PhoneFiled;
